import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { setCustomerAsync } from "../../Actions/CustomerAsyncActions";
import AuthProvider from "../../services/AuthProvider";
import authService from "../../services/authService";
import userService from "../../services/userService";
import versionService from "../../services/versionService";
import { setUser } from "../../slices/userSlice";
import { setVersions } from "../../slices/versionsSlice";
import { useAppDispatch, useAppSelector } from "../../storeHooks";
export const AppInit = ({ children, }) => {
    const dispatch = useAppDispatch();
    const language = useAppSelector((state) => state.currentLang.value);
    const [isInitialized, setIsInitialized] = useState(false);
    const loadInitialData = () => {
        userService
            .getMyProfile()
            .then((data) => {
            dispatch(setUser(data));
            if (data.customerId) {
                dispatch(setCustomerAsync({ id: data.customerId, name: data.userName }));
            }
            setIsInitialized(true);
        })
            .catch();
    };
    useEffect(() => {
        if (isInitialized && AuthProvider.getRefreshToken()) {
            versionService.getVersions().then((data) => {
                dispatch(setVersions(data));
            });
        }
    }, [isInitialized]);
    useEffect(() => {
        const init = AuthProvider.init();
        if (init === 2) {
            setIsInitialized(true);
        }
        else {
            if (init === 1) {
                authService
                    .refreshAuthToken(AuthProvider.getRefreshToken())
                    .then((data) => {
                    AuthProvider.setAuthToken({
                        token: data.access.accessToken,
                        expiration: data.access.accessExpiresOn,
                    });
                    AuthProvider.setRefreshToken({
                        token: data.access.refreshToken,
                        expiration: data.access.refreshExpiresOn,
                    });
                    AuthProvider.updateUser(data.user);
                    setIsInitialized(true);
                })
                    .catch(() => {
                    console.log("Failed to refresh token");
                    AuthProvider.setAuthToken({ token: null, expiration: null });
                    AuthProvider.setRefreshToken({ token: null, expiration: null });
                    AuthProvider.updateUser(null);
                    setIsInitialized(true);
                });
            }
            if (init === 0) {
                loadInitialData();
            }
        }
    }, [language]);
    return _jsx(_Fragment, { children: isInitialized ? children : null });
};
